import { defineSagaForService, DownloadServiceConfiguration } from '@repo/core'
import { getCommunicationDocument, getCommunications } from '@repo/mailbox-services'
import {
  communicationDocumentDownloadActions,
  communicationsDataActions,
} from '../../store/actions'

export const communicationsServiceConfig = defineSagaForService({
  [communicationsDataActions.getRequest.type]: {
    apiClientDomain: 'mailbox',
    service: getCommunications,
    actionTypeResponse: communicationsDataActions.getResponse.type,
    actionTypeRequest: communicationsDataActions.getRequest.type,
  },
})

export const communicationDocumentDownloadConfig: Record<string, DownloadServiceConfiguration> = {
  [communicationDocumentDownloadActions.downloadRequest.type]: {
    apiClientDomain: 'mailbox',
    service: getCommunicationDocument as DownloadServiceConfiguration['service'],
    actionTypeRequest: communicationDocumentDownloadActions.downloadRequest.type,
    actionTypeResponse: communicationDocumentDownloadActions.downloadResponse.type,
  },
}
